import React from "react";
import { Route, Routes } from "react-router-dom";

import Chat from "@/components/screens/Chat";
import { CHAT_MESSAGES } from "@/messages/chat/chat.messages";

const CustomerServicePage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Chat messages={CHAT_MESSAGES} />} />
      <Route path="/" element={<Chat messages={CHAT_MESSAGES} />} />
    </Routes>
  );
};

export default CustomerServicePage;
